import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacer.x1};
`;

const Block = styled.div`
  border-radius: ${tokens.radius.m};
  background: ${tokens.color.text_light};
  height: ${tokens.spacer.x2pt5};
  background-color: #f1f2f6;
  background: linear-gradient(
      100deg,
      rgba(255, 255, 255, 0) 40%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 60%
    )
    #f1f2f6;
  background-size: 200% 100%;
  background-position-x: 180%;
  animation: 2s loading ease-in-out infinite;
  @keyframes loading {
    to {
      background-position-x: -20%;
    }
  }
  @media (prefers-reduced-motion) {
    animation: none;
  }
`;

const ScreenReaderMessage = styled.span`
  position: absolute;
  top: auto;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  white-space: nowrap;
`;

export const PlaceholderText = (): JSX.Element => {
  const { t } = useTranslation('common');
  return (
    <Container>
      <Block aria-hidden />
      <Block aria-hidden />
      <ScreenReaderMessage>{t('states.loading')}</ScreenReaderMessage>
    </Container>
  );
};
